import { PostHog } from "posthog-js";
import { FEATURE_FLAGS } from "~/shared/lib/posthog/posthog.constants";

// Leaving this here as an example for future helpers
/*
export function canAccessShortlists(posthog?: PostHog) {
  return posthog?.isFeatureEnabled(FEATURE_FLAGS.RELEASE_SHORTLISTS) ?? false;
}
*/

export function canAccessParticipantJobDetail(posthog?: PostHog) {
  return posthog?.isFeatureEnabled(FEATURE_FLAGS.RELEASE_PARTICIPANT_JOB_DETAIL) ?? false;
}

export function canAccessMemberSetupFlow(posthog?: PostHog) {
  return posthog?.isFeatureEnabled(FEATURE_FLAGS.RELEASE_MEMBER_SETUP_FLOW) ?? false;
}

export function canAccessNewLogin(posthog?: PostHog) {
  return posthog?.isFeatureEnabled(FEATURE_FLAGS.RELEASE_NEW_LOGIN) ?? false;
}
